// ==============================|| OVERRIDES - TABLE ROW ||============================== //

export default function TableRow() {
  return {
    MuiTableRow: {
      styleOverrides: {
        root: {
          '&:last-of-type .MuiTableCell-root': { borderBottom: 'none' },
          '& .MuiTableCell-root:first-of-type': { paddingLeft: 20 },
          '& .MuiTableCell-root:last-of-type': { paddingRight: 20 }
        }
      }
    }
  };
}
